import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WebApiService } from './web-api.service';

@Injectable({
  providedIn: 'root',
})
export class HealthService {
  constructor(
    private httpClient: HttpClient,
    private webApiService: WebApiService
  ) {}

  getHealth(): Observable<any> {
    return this.httpClient.get(this.webApiService.getUrl(), {
      observe: 'response',
    });
  }
}
